import React, { useState } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import constants from '../../config/constants'
import useWindowDimensions from './WindowDimesnions'
import Popover from '@mui/material/Popover'

const CustomBreadMenu = (props) => {
  const { breadMenu, activeTab, handleChangeActiveTab } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const tabChangeButtonStyle = {
    color: 'white',
    fontSize: width >= constants.smBreakpoint ? '20px' : '16px',
    fontWeight: '500',
    height: '60px',
    padding: '0px 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: width >= constants.mdBreakpoint ? 'flex-start' : 'space-between',
    textTransform: 'capitalize',
    border: '1px solid',
    borderRadius: '50px 50px 0px 0px',
    borderColor: theme.palette.oxfordBlue,
    borderBottom: 'none',
    position: 'relative',
  }

  const popoverButtonStyle = {
    textTransform: 'capitalize',
    fontWeight: '400',
    color: theme.palette.oxfordBlue,
    fontSize: '20px',

    '&:hover': {
      background: 'inherit',
      color: theme.palette.violetsAreBlue,
    },
  }

  const handleClickMenuItem = (value) => {
    handleChangeActiveTab(value)
    handleClose()
  }

  return (
    <>
      {
        width >= constants.mdBreakpoint ?
        <Stack
          direction='row'
          alignItems='flex-start'
          justifyContent='flex-start'
        >
          {
            breadMenu.map((item, index) => (
              <Button
                key={index}
                variant='contained'
                disableRipple
                disableElevation
                onClick={() => handleChangeActiveTab(item.value)}
                sx={{
                  ...tabChangeButtonStyle,      
                  zIndex: activeTab === item.value ? 2 : 1,
                  marginLeft: index > 0 ? '-25px' : '0px',
                  background: activeTab === item.value ? theme.palette.violetsAreBlue : theme.palette.greenSheen,
                  '&:hover': {
                    background: activeTab === item.value ? theme.palette.violetsAreBlue : theme.palette.greenSheen,
                  },
                }}
              >{item.label}</Button>
            ))
          }
        </Stack> :
        <>
          {
            breadMenu.map((item, index) => (
              <Box key={index}>
                {
                  activeTab === item.value &&
                  <Button                
                    variant='contained'
                    disableRipple
                    disableElevation
                    endIcon={<ExpandMoreIcon />}
                    onClick={handleClick}
                    sx={{
                      ...tabChangeButtonStyle,
                      width: '100%',
                      background: theme.palette.violetsAreBlue,
                      '&:hover': {
                        background: theme.palette.violetsAreBlue,
                      },
                    }}
                  >{item.label}</Button>
                }
              </Box>              
            ))
          }
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Box sx={{ padding: '20px' }}>
              {
                breadMenu.map((item, index) => (
                  <Box key={index}>
                    <Button
                      variant='text'
                      disableRipple
                      disableElevation
                      sx={popoverButtonStyle}
                      onClick={() => handleClickMenuItem(item.value)}
                    >
                      {item.label}
                    </Button>
                  </Box>
                ))
              }
            </Box>        
          </Popover>
        </>
      }      
    </>
  )
}

export default CustomBreadMenu